import {ChangeDetectorRef, Component, ViewChild} from '@angular/core';
import {
  Alert,
  AlertController,
  Content,
  IonicPage,
  ItemSliding,
  Loading,
  LoadingController,
  Navbar,
  NavController,
  NavParams,
  Platform,
  Popover,
  PopoverController,
  Range,
  Select, TextInput
} from 'ionic-angular';
import {TranslateService} from "@ngx-translate/core";
import {ReaderService} from "../../providers/reader.service";
import {VizixService} from "../../providers/vizix.service";
import {AppConfigPage} from "../app-config/app-config";
import {isUndefined} from "ionic-angular/util/util";
import {TagReadResponse} from "../../models/reader-model/tagReadResponse";
import {
  CONFIGURATION_ERROR,
  INVALID_FORMAT,
  NAV_PARAM_LOOKUP_EPC_LIST,
  NAV_PARAM_RETURN_PAGE,
  NOT_FOUND,
  READER_MODE_GEIGER,
  SERVER_ERROR,
  TAG_INFORMATION_SOURCE_FIND_ITEM,
  UNKNOWN_ERROR, VALIDATION_INPUT_TAG
} from "../../app/app.constants";
import {TagItem} from "../../models/tagItem";
import {PopoverDetailsPage} from "../popover-details/popover-details";
import {FieldItem} from "../../models/FieldItem";
import {ValidateUpcPipe} from "../../pipes/validate-tag/validate-upc";
import {ValidateSkuPipe} from "../../pipes/validate-tag/validate-sku";
import {ValidateRfidPipe} from "../../pipes/validate-tag/validate-rfid";
import {PadUpcPipe} from "../../pipes/validate-tag/pad-upc";
import {PadSkuPipe} from "../../pipes/validate-tag/pad-sku";
import {PadRfidPipe} from "../../pipes/validate-tag/pad-rfid";
import {FormatDataTypePipe} from "../../pipes/format-data-type/format-data-type";
import {TableScriptReportResponse} from "../../models/TableScriptReportResponse";
import {ErrorResponse} from "../../models/ErrorResponse";
import {SimulatorService} from "../../providers/simulator.service";
import {DeviceSelectPage} from "../device-select/device-select";
import {Subscription} from "rxjs/Subscription";
import {Keyboard} from "@ionic-native/keyboard";
import {FindItemService} from "../../providers/find.item.service";
import {InsomniaService} from "../../providers/insomnia.service";
import {TagInformationService} from "../../providers/tag.information.service";

/**
 * Generated class for the FindItemPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-find-item',
  templateUrl: 'find-item.html',
  providers: [ValidateUpcPipe, ValidateSkuPipe, ValidateRfidPipe, PadUpcPipe, PadSkuPipe, PadRfidPipe, FormatDataTypePipe]
})

export class FindItemPage {

  private tag = '[FIND_ITEM]';

  // Variables that control what is being shown
  public isFindItemScreenShowing: boolean = false;
  public isGeigerMode: boolean = false;

  // If EnableZoneType == false
  public totalOnHands: number = 0;
  // If EnableZoneType == true
  public salesFloorOnHands: number = 0;
  public backRoomOnHands: number = 0;
  public unknownOnHands: number = 0;

  public selectedTag: string = null;
  public selectedUPC: string = null;
  public readerPower: number = 100;

  // public departmentList: DepartmentsZones[];
  // public selectedDepartment: DepartmentsZones;
  // public selectedZone: ZoneType;

  public loading: Loading;
  public alertReaderError: Alert;
  public alertInvalidFormatError: Alert;
  public alertNoOnHandsValueError: Alert;
  public alertReaderDisconnectedError: Alert;
  public alertNoInformationFoundError: Alert;
  public alertServerError: Alert;
  public alertUnknownError: Alert;
  public alertConfigurationError: Alert;
  public alertReportError: Alert;
  public alertReaderNotConnectedError: Alert;

  private isAlertShowing: boolean = false;

  public isTriggerPulled: boolean = false;
  public isRealTriggerPulled: boolean = false;

  public isPopPageActive: boolean = false; // Used to prevent multiple 'pop' calls

  // This array contains all the tags that appear in the list
  public inventoryShownArray: Array<TagItem> = [];

  private readerDisconnectSubscription: Subscription;

  // For the infinite scroll
  public popoverDetails: Popover;
  public showDim: boolean = false;

  public geigerPercentage: number = 0;

  public searchInputText: string = '';
  private autoSearchValue: string = null;
  private lookupEpcList: string[] = null;

  public isCameraEnabled = false;

  private inventorySearchSet: Set<string> = new Set(); // This array includes UNIQUE EPCs and UPCs returned by the Expected report

  private tagInformationResponse: FieldItem[] = [];

  public isKeyboardOpen: boolean = false;
  private keyboardHideSubscription: Subscription;

  private triggerPressTimer: any;

  public isDragging: boolean = false;

  private isInitialInitInventorySkipped: boolean = false; // To prevent ionViewDidEnter to call initInventory when comming from lookup

  @ViewChild(Navbar) navBar: Navbar;
  @ViewChild(Content) content: Content;
  @ViewChild('Select1') selectZone: Select;
  @ViewChild('Select2') selectDepartment: Select;
  @ViewChild('rangePower') rangeBarReaderPower: Range;
  @ViewChild('searchInput') inputTagField: TextInput;


  private barcodeAttempts = 0;

  private DidPageLoad: boolean = false;

  private returnPage: string;

  public isZoneTypeEnabled: boolean = false;

  public source = TAG_INFORMATION_SOURCE_FIND_ITEM;

  private isIosVersionLessThan11: boolean = false;

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              public translate: TranslateService,
              private readerService: ReaderService,
              private cdr: ChangeDetectorRef,
              public platform: Platform,
              private vizixService: VizixService,
              private loadingCtrl: LoadingController,
              private alertCtrl: AlertController,
              private keyboard: Keyboard,
              private popoverCtrl: PopoverController,
              private padUpc: PadUpcPipe,
              private simulatorService: SimulatorService,
              private findItemService: FindItemService,
              private _insomniaService: InsomniaService,
              private tagInformationService: TagInformationService) {

    this.autoSearchValue = navParams.get('autoSearch');
    console.log(this.tag, this.autoSearchValue ? 'Parameter received' : 'No parameter received',
      this.autoSearchValue ? this.autoSearchValue : null);
    this.returnPage = this.navParams.get(NAV_PARAM_RETURN_PAGE);
    this.lookupEpcList = this.navParams.get(NAV_PARAM_LOOKUP_EPC_LIST);

    this.isZoneTypeEnabled = this.vizixService.configurationApp.FindItemConfiguration.EnableZoneType.value;

    //if isCameraEnabled=true,it will have the option of barcode camera scan
    //this.isCameraEnabled = this.platform.is('cordova');

    // Init all alerts
    this.initAlerts();
    // this.initDeptsZones();

    //ask ios version
    this.askPlatformOs();

    // Init Back button
    this.platform.ready().then((readySource) => {
      this.platform.registerBackButtonAction(() => {
        this.goBack();
      });
    });
  }


  //Ask OS and Ios version
  askPlatformOs() {
    this.platform.ready().then(() => {
      if (this.platform.is('android')) {
        this.isIosVersionLessThan11 = false;
      } else if (this.platform.is('ios')) {
        const osVersionNumber = this.platform.version().num;
        this.isIosVersionLessThan11 = osVersionNumber < 11;
      } else if (this.platform.is('mobileweb')) {
        this.isIosVersionLessThan11 = false;
      } else {
        this.isIosVersionLessThan11 = false;
      }
    });
  }

  ionViewDidLoad() {
    this.isInitialInitInventorySkipped = true; // To prevent ionViewDidEnter to call initInventory the first time

    this.DidPageLoad = true;
    //insomnia service with the method insomniaKeepAwakeScreen() will Prevent the screen of the mobile device from falling asleep. (Only in this screen)
    this._insomniaService.insomniaKeepAwakeScreen().subscribe(
      (response: any) => {
        console.log('[INSOMNIA PLUGIN]', response);
      }, (error) => {
        console.error('[INSOMNIA PLUGIN]', 'Error Keeping application awake');
      }
    );

    // set power default reader
    this.readerPower = this.vizixService.configurationApp.FindItemConfiguration.DefaultPowerLevelReader.value;

    this.keyboard.onKeyboardShow().subscribe(() => {
      this.isKeyboardOpen = true;
      this.content.resize();
    });

    this.keyboard.onKeyboardHide().subscribe(() => {
      this.isKeyboardOpen = false;
      this.content.resize();
    });

    this.vizixService.VizixUpdateReportDefinitionIdentifyTag();

    if (this.autoSearchValue) {
      this.searchInputText = this.autoSearchValue.toUpperCase();
      this.isReaderConnected().then(isConnected => {
        this.validateAndHideKeyboard(this.autoSearchValue.toUpperCase());
      }, error => {
        this.alertReaderNotConnectedError.present();
        this.isAlertShowing = true;
      });
    } else if (this.lookupEpcList) {
      this.isReaderConnected().then(isConnected => {
        this.initLookupEpcList();
      }, error => {
        this.alertReaderNotConnectedError.present();
        this.isAlertShowing = true;
      });
    } else {
      this.initReaderStatusListenerIfConnected();
      this.changeBarcodeMode();
    }
  }

  initLookupEpcList() {
    this.isReaderConnected().then((isConnected) => {
      if (isConnected) {
        // Init maps with the EPCs from the passed parameters
        this.initMaps(this.lookupEpcList);

        // Now we initialize the reader in inventory mode
        this.initReaderInventory();

        this.showFindItemScreen(true);
      } else {
        this.alertReaderNotConnectedError.present();
        this.isAlertShowing = true;
      }
    });
  }

  showLoadingInitializingReader(message?: string) {
    if (!this.loading) {
      this.loading = this.loadingCtrl.create({
        content: this.translate.instant('find_item.loadings.initializing_scanner')
      });
      this.dismissAll();
      this.loading.present();
      this.isAlertShowing = true;
    }
  }

  initReaderStatusListenerIfConnected() {
    this.isReaderConnected().then((isConnected) => {
      if (isConnected) {
        this.initReaderStatusListener();
      } else {
        this.alertReaderNotConnectedError.present();
        this.isAlertShowing = true;
      }
    });
  }

  ionViewWillEnter() {
  }

  ionViewDidEnter() {
    //insomnia service with the method insomniaKeepAwakeScreen() will Prevent the screen of the mobile device from falling asleep. (Only in this screen)
    this._insomniaService.insomniaKeepAwakeScreen().subscribe(
      (response: any) => {
        console.log('[INSOMNIA PLUGIN]', response);
      }, (error) => {
        console.error('[INSOMNIA PLUGIN]', 'Error Keeping application awake');
      }
    );

    this.content.resize();

    if (!this.DidPageLoad) {
      this.showLoadingInitializingReader();
    }
    this.initReaderStatusListenerIfConnected();
    if (!this.autoSearchValue) {
      if (this.isGeigerMode) {
        this.cancelGeigerMode();
      } else if (this.isFindItemScreenShowing && !this.isInitialInitInventorySkipped) {
        this.initReaderInventory();
      } else {
        this.changeBarcodeMode();
      }
    } else {
      if (this.isFindItemScreenShowing && !this.isInitialInitInventorySkipped) {
        this.initReaderInventory();
      }
    }

    if (!this.DidPageLoad) {
      this.dismissLoading();
    }
    this.DidPageLoad = false;
    this.cdr.reattach();
    this.cdr.detectChanges();

    this.platform.registerBackButtonAction(() => {
      this.goBack();
    });

    this.setTriggerListener();
  }

  openBarcodeCamera() {
    this.readerService.initBarcodeCameraScan().then((barcode) => {
      this.searchInputText = barcode.value;
      this.validateAndHideKeyboard(barcode.value);
    }, (error) => {
      console.log(this.tag, 'Error barcode camera', error);
    });
  }

  changeBarcodeMode() {
    this.isReaderConnected().then(() => {
      this.readerService.initBarcodeScan().subscribe(
        (result) => {
          this.barcodeAttempts = 0;
          console.log(this.tag, 'BARCODE response', result);
          console.log(this.tag, result);
          if (result.value != null) {
            this.searchInputText = result.value;
            this.cdr.detectChanges();
            this.validateAndHideKeyboard(this.searchInputText);
          }
        },
        (e) => {
          console.log(this.tag, 'error');
          console.log(this.tag, e);
          if (e.code == 800 && this.barcodeAttempts <= 3) {
            this.barcodeAttempts++;
            setTimeout(() => {
              this.changeBarcodeMode();
            }, 500);
          }
        }
      );
    });
  }


  onScrollDown() {
    console.log(this.tag, 'Adding items to list');
    // for (let i = 0; i < this.pageSize; i++) {
    //   this.inventoryShownArray.push(new TagItem("AE100000000000000000000" + String(this.inventoryShownArray.length), null, false, false));
    // }
  }

  showErrorAlert(error: ErrorResponse) {
    this.dismissAll();
    console.log(this.tag, 'Showing error', error);
    if (error.errorCode != null) {
      if (error.errorCode == NOT_FOUND) {
        this.alertNoInformationFoundError.present();
        if (!this.autoSearchValue) this.clearInput(true, true);
      } else if (error.errorCode == INVALID_FORMAT) {
        this.alertInvalidFormatError.present();
        if (!this.autoSearchValue) this.clearInput(true, true);
      } else if (error.errorCode == SERVER_ERROR) {
        this.alertServerError.present();
        if (!this.autoSearchValue) this.clearInput(true);
      } else if (error.errorCode == UNKNOWN_ERROR) {
        this.alertUnknownError.present();
        if (!this.autoSearchValue) this.clearInput(true);
      } else if (error.errorCode == CONFIGURATION_ERROR) {
        this.alertConfigurationError.present();
        if (!this.autoSearchValue) this.clearInput(true);
      }
    } else {
      this.alertServerError.present();
      if (!this.autoSearchValue) this.clearInput(true);
    }
    this.isAlertShowing = true;
  }

  getExpected(toSearchValue: string) {
    this.isFindItemScreenShowing = true;

    if (toSearchValue) {
      console.log(this.tag, 'Executing Expected Report for ' + this.vizixService.configurationApp.IdentifyItemConfiguration.FieldValueSOH.value, toSearchValue);
      let filtersJson = {};

      // TODO: ADD UPC TO CONFIG THING FOR THE FILTER LABEL FOR THE EXPECTED REPORT (ALSO THE FIELD VALUE)
      filtersJson['SKU'] = String(toSearchValue);
      filtersJson['storeID'] = String(this.vizixService.getStoreId());
      console.log(this.tag, 'Filters JSON:', filtersJson);

      this.vizixService.VizixPostReportExecutionFindItemExpected(filtersJson).subscribe((response: TableScriptReportResponse) => {
          console.log(this.tag, 'Expected report response', response);

          if (response.data.length > 0) {
            // Init maps with the UPCs and EPCs returned by the report
            this.initMaps(response);

            // Now we initialize the reader in inventory mode
            this.initReaderInventory();
            this.dismissLoading();
          } else {
            console.log(this.tag, 'On hands value = 0');
            this.dismissAll();
            this.initAlertNoOnHandsValueError(String(toSearchValue));
            this.alertNoOnHandsValueError.present();
            this.isAlertShowing = true;
          }
        },
        err => {
          console.log(this.tag, 'error' + err);
          this.dismissAll();
          this.alertServerError.present();
          this.isAlertShowing = true;
        },
        () => {
        }
      );
    } else {
      console.log(this.tag, 'Couldn\'t get Expected information, FieldValueSOH not configured properly');
      this.dismissLoading();
    }
  }

  onFieldValueFound(value) {
    this.getExpected(value);
  }

  onError(error) {
    this.handleError(error);
  }

  private handleError(error) {
    this.dismissLoading();
    this.dismissAll();
    this.isAlertShowing = true;
    if (error.errorCode != null) {
      if (error.errorCode == NOT_FOUND) {
        this.alertNoInformationFoundError.present();
      } else if (error.errorCode == INVALID_FORMAT) {
        this.alertInvalidFormatError.present();
      } else if (error.errorCode == SERVER_ERROR) {
        this.alertServerError.present();
      } else if (error.errorCode == UNKNOWN_ERROR) {
        this.alertUnknownError.present();
      } else if (error.errorCode == CONFIGURATION_ERROR) {
        this.alertConfigurationError.present();
      }
    } else {
      this.alertUnknownError.present();
    }
  }

  resetMaps() {
    this.totalOnHands = 0;
    this.inventoryShownArray = [];
    this.inventorySearchSet = new Set();
  }

  initMaps(response: TableScriptReportResponse | string[]) {
    if (response instanceof TableScriptReportResponse) {

      this.resetMaps();

      const initRow = (zoneType: string, row: Array<string>) => {
        for (let i = 0; i < response.columnNames.length; i++) {
          if (response.columnNames[i] === 'UPCs' || response.columnNames[i] === 'EPCs') {
            if (row[i].split('|').length > 1) {
              for (let tag of row[i].split('|')) {
                this.inventorySearchSet.add(tag);
              }
            } else {
              if (row[i]) {
                this.inventorySearchSet.add(row[i]);
              }
            }
          } else if (response.columnNames[i] === 'QtyOnHand') {
            try {
              if (zoneType === 'SalesFloor') {
                this.salesFloorOnHands += Number(row[i]); // ZoneType enabled Salesfloor
              } else if (zoneType === 'StockRoom') {
                this.backRoomOnHands += Number(row[i]); // ZoneType enabled StockRoom
              } else if (zoneType) {
                this.unknownOnHands += Number(row[i]); // ZoneType enabled Unknown
              } else if (!this.isZoneTypeEnabled) {
                this.totalOnHands += Number(row[i]); // ZoneType disabled
              }
            } catch (exception) {
              console.log(this.tag, 'QtyOnHands not number?');
            }
          }
        }
      };

      if (this.isZoneTypeEnabled) {
        for (let row of response.data) {

          // First get the column index for the 'ZoneType' value
          let zoneTypeIndex = response.columnNames.indexOf('ZoneType');
          if (zoneTypeIndex > -1) {
            if (row[zoneTypeIndex]) {
              initRow(row[zoneTypeIndex], row);
            }
          } else {

            // The report does not have the ZoneType column!
            this.isAlertShowing = true;
            this.alertConfigurationError.present();
          }
        }

        // Now add them together
        this.totalOnHands = this.salesFloorOnHands + this.backRoomOnHands + this.unknownOnHands;

      } else {
        for (let row of response.data) {
          initRow(null, row);
        }
      }

      if (this.autoSearchValue) {
        this.findItemService.getItems(this.autoSearchValue).then((tagItemList: TagItem[]) => {
          console.log('Item List from database:', tagItemList);
          if (tagItemList.length > 0) {
            this.inventoryShownArray = [];
            for (let tagItem of tagItemList) {
              tagItem.isFound = false; // To prevent slide bug TODO: REVIEW
              this.inventoryShownArray.push(tagItem);
            }
            this.findItemService.removeItemsFromDb(this.autoSearchValue);
          }
        }, (error) => {
          console.log('Error', error);
        }).catch((error) => {
          console.log('Error gerring saved items from database', error);
        })
      }
    } else { // response type is string[]
      for (let epc of <string[]>response) {
        this.inventorySearchSet.add(epc);
      }
    }

    console.log(this.tag, 'InitMaps() result map', this.inventorySearchSet);
  }

  initAlerts() {
    this.initAlertReaderDisconnectedError();
    this.initAlertReaderNotConnectedError();
    this.initAlertReaderError();
    this.initAlertInvalidFormatError();
    this.initAlertNoOnHandsValueError();
    this.initAlertNoInformationFoundError();
    this.initAlertServerError();
    this.initAlertConfigurationError();
    this.initAlertReportError();
    this.initAlertUnknownError();
  }

  // Alert that shows when there is an error uploading CycleCount
  initAlertConfigurationError() {
    this.alertConfigurationError = this.alertCtrl.create({
      title: this.translate.instant('find_item.alerts.configuration_error.title'),
      message: this.translate.instant('find_item.alerts.configuration_error.message'),
      enableBackdropDismiss: false,
      buttons: [
        {
          text: this.translate.instant('find_item.alerts.configuration_error.ok'),
          handler: () => {
            this.isAlertShowing = false;
            this.initAlertConfigurationError(); // We call this recursively because the alert is destroyed on dismiss
            this.clearInput(true, true);
          }
        }
      ]
    });
  }

  // Alert that shows when there is an error uploading CycleCount
  initAlertReportError() {
    this.alertReportError = this.alertCtrl.create({
      title: this.translate.instant('find_item.alerts.report_error.title'),
      message: this.translate.instant('find_item.alerts.report_error.message'),
      enableBackdropDismiss: false,
      buttons: [
        {
          text: this.translate.instant('find_item.alerts.report_error.ok'),
          handler: () => {
            this.isAlertShowing = false;
            this.initAlertReportError(); // We call this recursively because the alert is destroyed on dismiss
            // this.showFindItemScreen(false);
            this.clearInput(true, true);
          }
        }
      ]
    });
  }

  // Alert that shows when there is an error uploading CycleCount
  initAlertReaderError() {
    this.alertReaderError = this.alertCtrl.create({
      title: this.translate.instant('find_item.alerts.reader_error.title'),
      message: this.translate.instant('find_item.alerts.reader_error.message'),
      enableBackdropDismiss: false,
      buttons: [
        {
          text: this.translate.instant('find_item.alerts.reader_error.ok'),
          handler: () => {
            this.isAlertShowing = false;
            this.initAlertReaderError(); // We call this recursively because the alert is destroyed on dismiss
            // this.goBack();
          }
        }
      ]
    });
  }

  // Alert that shows when there is an error uploading CycleCount
  initAlertInvalidFormatError() {
    this.alertInvalidFormatError = this.alertCtrl.create({
      title: this.translate.instant('find_item.alerts.invalid_format.title'),
      message: this.translate.instant('find_item.alerts.invalid_format.message'),
      enableBackdropDismiss: false,
      buttons: [
        {
          text: this.translate.instant('find_item.alerts.invalid_format.ok'),
          handler: () => {
            this.isAlertShowing = false;
            // this.dismissAll();
            this.initAlertInvalidFormatError(); // We call this recursively because the alert is destroyed on dismiss
            this.clearInput(true, true);
          }
        }
      ]
    });
  }

  // Alert that shows when there is an error uploading CycleCount
  initAlertNoOnHandsValueError(sku?: string) {
    this.alertNoOnHandsValueError = this.alertCtrl.create({
      title: this.translate.instant('find_item.alerts.no_on_hands_value.title'),
      message: this.translate.instant('find_item.alerts.no_on_hands_value.message') + (sku ? (': ' + sku) : ''),
      enableBackdropDismiss: false,
      buttons: [
        {
          text: this.translate.instant('find_item.alerts.no_on_hands_value.ok'),
          handler: () => {
            this.isAlertShowing = false;
            // this.dismissAll();
            this.initAlertNoOnHandsValueError(sku); // We call this recursively because the alert is destroyed on dismiss
            this.clearInput(true, true);
          }
        }
      ]
    });
  }

  // Alert that shows when the reader disconnects
  initAlertReaderDisconnectedError() {
    this.alertReaderDisconnectedError = this.alertCtrl.create({
      title: this.translate.instant('find_item.alerts.reader_disconnected.title'),
      message: this.translate.instant('find_item.alerts.reader_disconnected.message'),
      enableBackdropDismiss: false,
      buttons: [
        {
          text: this.translate.instant('find_item.alerts.reader_disconnected.ok'),
          handler: () => {
            this.isAlertShowing = false;
            this.isPopPageActive = true;
            this.popAndSave();
            // this.initAlertReaderDisconnectedError(); // We call this recursively because the alert is destroyed on dismiss
            // this.clearInput(true);
          }
        }
      ]
    });
  }

  // Alert that shows when the reader is not connected and user tries to do something in the module
  initAlertReaderNotConnectedError() {
    this.alertReaderNotConnectedError = this.alertCtrl.create({
      title: this.translate.instant('menu_tracker_retail.alerts.error_pair.title'),
      message: this.translate.instant('menu_tracker_retail.alerts.error_pair.message'),
      buttons: [
        {
          text: this.translate.instant('menu_tracker_retail.alerts.error_pair.cancel'),
          role: 'cancel',
          handler: () => {
            this.dismissLoading();
            this.isAlertShowing = false;
            this.popAndSave();
          }
        },
        {
          text: this.translate.instant('menu_tracker_retail.alerts.error_pair.ok'),
          handler: () => {
            this.dismissLoading();
            this.isAlertShowing = false;
            this.initAlertReaderNotConnectedError();
            this.navCtrl.push(DeviceSelectPage);
            // this.navCtrl.popToRoot().then(() => { // To prevent the page stack to increase every time
            // });
          }
        }
      ]
    });
  }

  // Alert that shows when no information is found for the input tag
  initAlertNoInformationFoundError() {
    this.alertNoInformationFoundError = this.alertCtrl.create({
      title: this.translate.instant('find_item.alerts.no_information.title'),
      message: this.translate.instant('find_item.alerts.no_information.message'),
      enableBackdropDismiss: false,
      buttons: [
        {
          text: this.translate.instant('find_item.alerts.no_information.ok'),
          handler: () => {
            this.isAlertShowing = false;
            this.initAlertNoInformationFoundError(); // We call this recursively because the alert is destroyed on dismiss
            this.clearInput(true, true);
          }
        }
      ]
    });
  }

  // Alert that shows when there is an error in a server request
  initAlertServerError() {
    this.alertServerError = this.alertCtrl.create({
      title: this.translate.instant('find_item.alerts.server_error.title'),
      message: this.translate.instant('find_item.alerts.server_error.message'),
      enableBackdropDismiss: false,
      buttons: [
        {
          text: this.translate.instant('find_item.alerts.server_error.ok'),
          handler: () => {
            this.isAlertShowing = false;
            this.initAlertServerError(); // We call this recursively because the alert is destroyed on dismiss
            this.clearInput(true, true);
          }
        }
      ]
    });
  }

  // Alert that shows when there is an error in a server request
  initAlertUnknownError() {
    this.alertUnknownError = this.alertCtrl.create({
      title: this.translate.instant('find_item.alerts.unknown_error.title'),
      message: this.translate.instant('find_item.alerts.unknown_error.message'),
      enableBackdropDismiss: false,
      buttons: [
        {
          text: this.translate.instant('find_item.alerts.unknown_error.ok'),
          handler: () => {
            this.isAlertShowing = false;
            this.initAlertUnknownError(); // We call this recursively because the alert is destroyed on dismiss
            this.clearInput(true, true);
          }
        }
      ]
    });
  }

  private initReaderStatusListener() {
    console.log(this.tag, 'Initializing Reader Status Listener');
    this.readerDisconnectSubscription = this.readerService.setStatusListener().subscribe((response) => {
      if (response.hasOwnProperty('connected') && !response.connected) {
        console.log(this.tag, 'Reader disconnected!');
        this.dismissAll();
        this.alertReaderDisconnectedError.present();
        this.isAlertShowing = true;
      }
    }, (error) => {
      this.dismissAll();
      this.alertReaderError.present();
      this.isAlertShowing = true;
    });
  }

  unsubscribeAll() {
    if (this.readerDisconnectSubscription) {
      this.readerDisconnectSubscription.unsubscribe();
    }
  }

  validateAndHideKeyboard(tag: string) {
    if (this.platform.is('cordova') && this.isKeyboardOpen) {
      this.keyboard.close();
      this.keyboardHideSubscription = this.keyboard.onKeyboardHide().subscribe(() => {
        this.isKeyboardOpen = false;
        this.dismissAlerts();
        this.showLoading();
        this.tagInformationService.setTag(tag, this.source, this.vizixService.configurationApp.IdentifyItemConfiguration.FieldValueSOH.value);
        this.keyboardHideSubscription.unsubscribe();
      });
    } else {
      this.dismissAlerts();
      this.showLoading();
      this.tagInformationService.setTag(tag, this.source, this.vizixService.configurationApp.IdentifyItemConfiguration.FieldValueSOH.value);
    }
  }

  // Called every time we do a reader operation
  isReaderConnected(): Promise<boolean> {
    return new Promise<boolean>(resolve => {
      this.readerService.isConnected().subscribe(
        (result) => {
          if (result) {
            console.log(this.tag, 'Reader is connected');
            resolve(true); // Connected
          } else {
            this.rangeBarReaderPower.disabled = true;
            console.log(this.tag, "Reader not connected"); // Not connected
            resolve(false);
          }
        },
        (error) => {
          console.log(this.tag, "Reader not connected", error); // Not connected
          resolve(false);
        }
      );
    });
  }

  initShowDetailsPopover(title: string, fields: Array<FieldItem>) {
    // Initialize popoverDetails with the new product status list and the current status
    this.popoverDetails = this.popoverCtrl.create(PopoverDetailsPage,
      {
        title: title,
        tag: this.autoSearchValue,
        isImageAviable: true,
        showGeigerButton: false
      }, {showBackdrop: true, cssClass: 'details-popover'});
    this.showDim = true;
    this.dismissAll();
    this.popoverDetails.present(); // Without event {ev: event}, the popoverDetails shows in the middle
    this.isAlertShowing = true;
    this.popoverDetails.onWillDismiss(() => {
      this.showDim = false;
      this.isAlertShowing = false;
    });
  }

  // Go to settings page
  goToAppConfig() {
    if (!this.isTriggerPulled) {
      this.stopReader();
      let returnNavParams = {};
      returnNavParams[NAV_PARAM_RETURN_PAGE] = this.returnPage;
      this.navCtrl.push(AppConfigPage, returnNavParams);

    }
  }

  openInfo() {
    console.log(this.tag, 'Click on info', this.searchInputText);
    this.initShowDetailsPopover(this.translate.instant('cycle_count.popovers.details.title'), this.tagInformationResponse);
  }

  setReaderPower() {
    this.readerService.dynamicPowerEnable(true);
    this.isReaderConnected().then(() => {
      this.readerService.setReaderPower(this.readerPower, READER_MODE_GEIGER).subscribe(
        (response: any) => {
          console.log(this.tag, 'Set Reader Power Response', response);
          if (this.isGeigerMode && this.isFindItemScreenShowing == false) {
            this.setTriggerListener();
          }
        }, (error) => {
          console.log(this.tag, 'ERROR', error);
        }
      );
    }, () => {
      this.dismissAll();
      this.alertReaderError.present();
      this.isAlertShowing = true;
    });
  }

  // Sets the reader to the MAX power percentage
  setReaderPowerMax(): Promise<boolean> {
    return new Promise<boolean>(resolve => {
      this.isReaderConnected().then(() => {
        this.readerService.setReaderPower(100, READER_MODE_GEIGER).subscribe(
          (response: any) => {
            if (response) {
              console.log(this.tag, 'Reader Power set to', 100);
              resolve(true);
            } else {
              resolve(false);
            }
          }, (error) => {
            console.log(this.tag, 'ERROR', error);
            resolve(false);
          }
        );
      }, () => {
        this.dismissAll();
        this.alertReaderError.present();
        this.isAlertShowing = true;
      });
    });
  }

  ionViewWillLeave() {
    //insomnia service with the method insomniaAllowScreenSleepAgain will screen sleep again when go to other page
    this._insomniaService.insomniaAllowScreenSleepAgain().subscribe(
      (response: any) => {
        console.log('[INSOMNIA PLUGIN]', response);
      }, (error) => {
        console.error('[INSOMNIA PLUGIN]', 'Error allowing appliccation sleep again');
      }
    );

    this.unsubscribeAll();
    this.stopReader();
    this.cdr.detach();
  }

  showFindItemScreen(showFindItemScreen: boolean) {
    if (showFindItemScreen) {
      this.isReaderConnected().then(() => {
        this.isFindItemScreenShowing = showFindItemScreen;
        this.cdr.detectChanges();
      }, () => {
        console.log(this.tag, 'Reader not connected!');
        this.dismissAll();
        this.alertReaderError.present();
        this.isAlertShowing = true;
      });
    } else {
      this.isFindItemScreenShowing = false;
      this.cdr.detectChanges();
      this.stopReader();
    }
  }

  // This one is called because it sets the reader power on sstart
  initReaderInventoryInitial(cb?) {
    this.setReaderPowerMax().then(success => {
      if (success) {
        if (cb) {
          cb()
        }
        this.initReaderInventory();
      } else {
        this.dismissAll();
        if (this.isAlertShowing) {
          this.alertReaderError.present();
          this.isAlertShowing = true;
        }
      }
    });
  }

  stopReader() {
    this.isReaderConnected().then(() => {
      this.readerService.stopScanCC().subscribe(
        (response: any) => {
          // Tag read
          console.log(this.tag, 'Stop scan response', response);
        }, (error) => {
          console.log(this.tag, 'ERROR', error);
        }
      );
    }, () => {
      this.dismissAll();
      this.alertReaderError.present();
      this.isAlertShowing = true;
    });
  }

  simulateTriggerPulled() {
    this.isTriggerPulled = true;
    if (this.simulatorService.isSimulatorEnabled) {
      this.isRealTriggerPulled = true;
    }
    this.cdr.detectChanges();
    this.readerService.simulateTriggerPress().subscribe(
      (response) => {
        console.log(this.tag, 'Trigger Pulled', response);
        // this.setTriggerListener();
      },
      (error) => {
        console.log(this.tag, 'Trigger Pull error', error);
      }
    );

    this.setTriggerListener();
  }

  simulateTriggerReleased(temporal: boolean) {
    this.isTriggerPulled = false;

    if (this.simulatorService.isSimulatorEnabled) {
      this.isRealTriggerPulled = false;
    }

    this.geigerPercentage = 0;
    this.readerService.simulateTriggerRelease().subscribe(
      (response) => {
        console.log(this.tag, 'Trigger Released', response);
        // this.setTriggerListener();
      },
      (error) => {
        console.log(this.tag, 'Trigger Released error', error);
      }
    );
    if (!temporal && this.isGeigerMode) {
      setTimeout(() => {
        this.cancelGeigerMode();
      }, 500);
    }
    this.cdr.detectChanges();


    this.setTriggerListener();
  }

  toggleTrigger() {
    if (this.isTriggerPulled) {
      this.simulateTriggerReleased(false);
    } else {
      this.simulateTriggerPulled();
    }
  }

  // This function returns the real trigger listener (from the reader itself)
  setTriggerListener() {
    if (this.readerService.setTriggerListener()) {
      this.readerService.setTriggerListener().subscribe(
        (triggerResponse: boolean) => {
          console.log(this.tag, 'Trigger State: ', triggerResponse);
          this.isTriggerPulled = triggerResponse;
          this.isRealTriggerPulled = triggerResponse;
          clearTimeout(this.triggerPressTimer);
          if (!this.isTriggerPulled && this.isGeigerMode) {
            this.cancelGeigerMode();
          }
          this.cdr.detectChanges();
        }, (error) => {
          console.log(this.tag, 'Trigger State error: ', error);
        }
      );
    } else {
      console.log(this.tag, 'Trigger Observer not set!');
    }
  }

  onDragItem(itemSliding: ItemSliding, item: TagItem) {
    let percent = itemSliding.getSlidingPercent();
    if (percent >= 1) {
      // is showing found
      console.log(this.tag, item.epc, 'Found');
      item.isFound = true;
    } else {
      // not showing found
      console.log(this.tag, item.epc, 'Not Found');
      item.isFound = false;
    }
  }

  initReaderInventory() {
    this.isInitialInitInventorySkipped = false;
    console.log(this.tag, 'Initializing Inventory Mode');
    this.readerService.initInventory(Array.from(this.inventorySearchSet)).subscribe(
      (tagResponse: TagReadResponse) => {
        // Tag read
        console.log(this.tag, 'Inventory TAG: ', tagResponse);
        this.processTagInventory(tagResponse);
      }, (error) => {
        console.log(this.tag, 'ERROR', error);
      }
    );
  }

  // Process Tag in Inventory mode
  processTagInventory(tag: TagReadResponse) {
    if (!this.isGeigerMode) {
      // first we check if it is not in the found list (to ignore)
      for (let tagShown of this.inventoryShownArray) {
        if (tag.value == tagShown.epc && tagShown.isFound) {
          return;
        }
      }

      if (tag.upc) { // SGTIN
        tag.upc = this.padUpc.transform(tag.upc);
        // First we check if the tag is in the array of values to search
        if (this.inventorySearchSet.has(tag.upc)) {
          this.switchToGeigerForTag(tag);
        } else { // If not found by UPC, we check by EPC TODO: ANALYZE IF NECESSARY
          if (this.inventorySearchSet.has(tag.value)) {
            this.switchToGeigerForTag(tag);
          } // else, tag not found, skip
        }
      } else { // GTIN
        if (this.inventorySearchSet.has(tag.value)) {
          this.switchToGeigerForTag(tag);
        } // else, tag not found, skip
      }
    }
  }

  switchToGeigerForTagTemplate(tag: TagItem, event: any) {

    setTimeout(() => {
      if (event.changedTouches[0].target.innerText.trim() == "Found" && event.changedTouches[0].target.clientWidth == 0) {
        console.log(this.tag, tag.epc, 'Not Found');
        tag.isFound = false;
      }
    }, 700)


    if (!this.isDragging) {
      this.switchToGeigerForTag(new TagReadResponse().fromTagItem(tag), true)
    } else {
      this.isDragging = false;
    }
  }

  switchToGeigerForTag(tag: TagReadResponse, fromTemplate?: boolean) {
    this.isGeigerMode = true;

    console.log(this.tag, 'TAG FOUND!', tag);

    if (this.simulatorService.isSimulatorEnabled) {
      this.simulateTriggerReleased(true);
    }

    if (!fromTemplate) {
      this.addToListShown(tag);
    }
    this.initReaderGeigerMode(tag.value, tag.upc, !fromTemplate);
    this.triggerPressTimer = setTimeout(() => this.simulateTriggerPulled(), 200);
  }

  addToListShown(tag: TagReadResponse) {
    console.log(this.tag, 'Adding to list', tag);
    let inList: boolean = false;
    let inListTag: TagItem = null;

    // Check if tag is not already in the shown list
    for (let shownTag of this.inventoryShownArray) {
      if (shownTag.epc == tag.value) {
        inList = true;
        inListTag = shownTag;
        break;
      }
    }

    if (!inList) {
      console.log(this.tag, 'Tag not in list');
      // If the RSSI is greater than the Acceptance Criteria, add it directly to the top
      if (tag.rssiPercentage >= this.vizixService.configurationApp.FindItemConfiguration.ProximityAcceptanceCriteriaReader.value) {
        console.log(this.tag, 'Unshift', tag);
        this.inventoryShownArray.unshift(new TagItem(tag.value, tag.upc ? tag.upc : null, true, false));
        this.cdr.detectChanges();
      } else { // If not, add it to the bottom
        console.log(this.tag, 'Push', tag);
        this.inventoryShownArray.push(new TagItem(tag.value, tag.upc ? tag.upc : null, false, false)); // TODO: Must be: ...null, false, false
        this.cdr.detectChanges();
      }
    } else { // If already on the list, set swipeable to true and move it to the top
      console.log(this.tag, 'Tag already in list');
      if (tag.rssiPercentage >= this.vizixService.configurationApp.FindItemConfiguration.ProximityAcceptanceCriteriaReader.value) {
        inListTag.isSwipeable = true;
        this.addToListShownTop(inListTag);
      }
    }
    this.cdr.detectChanges();
  }

  // Swap to top
  addToListShownTop(inListTag: TagItem) {
    let index = this.inventoryShownArray.indexOf(inListTag);
    for (let i = index; i > 0; i--) { // Swap to top using array destructuring
      [this.inventoryShownArray[i], this.inventoryShownArray[i - 1]] = [this.inventoryShownArray[i - 1], this.inventoryShownArray[i]];
    }
    this.cdr.detectChanges();
  }

  // Process Tag in Geiger mode
  processTagGeiger(tag: string, tagResponse: TagReadResponse) {
    if (this.isTriggerPulled) { // To prevent messages to arrive after trigger is released
      this.geigerPercentage = tagResponse.rssiPercentage < 100 ? tagResponse.rssiPercentage : 100;
      if (tagResponse.rssiPercentage >= this.vizixService.configurationApp.FindItemConfiguration.ProximityAcceptanceCriteriaReader.value) {
        for (let shownTag of this.inventoryShownArray) {
          if (shownTag.epc == tag) {
            shownTag.isSwipeable = true;
            this.addToListShownTop(shownTag);
            break;
          }
        }
      }
    } else {
      this.geigerPercentage = 0;
    }
    this.cdr.detectChanges();
  }

  // Init geiger mode
  initReaderGeigerMode(tag: string, upc: string, simulateTriggerPress: boolean) {

    this.setTriggerListener();
    this.selectedTag = tag;
    this.selectedUPC = upc ? upc : null;

    this.cdr.detectChanges();
    this.readerService.initGeiger(tag).subscribe(
      (tagResponse: TagReadResponse) => {
        console.log(this.tag, 'Geiger response', tagResponse);
        this.processTagGeiger(tag, tagResponse);
      }, (error) => {
        console.log(this.tag, 'ERROR', error);
      }
    );

    if (simulateTriggerPress) {
      this.triggerPressTimer = setTimeout(() => {
        if (!this.isTriggerPulled && this.isRealTriggerPulled) {
          this.simulateTriggerPulled();
        }
      }, 200);
    }
  }

  showLoading(message?: string) {
    if (!this.loading) {
      this.loading = this.loadingCtrl.create({
        content: message ? message : 'Please Wait'
      });
      this.dismissAll();
      this.loading.present();
      this.isAlertShowing = true;
    }
  }

  dismissAll() {
    this.dismissLoading();
    this.dismissAlerts();
  }

  dismissLoading() {
    if (this.loading && this.isAlertShowing) {
      this.loading.dismiss();
      this.loading = null;
    }
    this.isAlertShowing = false;
  }

  dismissAlerts() {
    if (this.alertServerError) {
      this.alertServerError.dismiss();
      this.initAlertServerError();
    }
    if (this.alertNoInformationFoundError) {
      this.alertNoInformationFoundError.dismiss();
      this.initAlertNoInformationFoundError();
    }
    if (this.alertInvalidFormatError) {
      this.alertInvalidFormatError.dismiss();
      this.initAlertInvalidFormatError();
    }
    if (this.alertReaderError) {
      this.alertReaderError.dismiss();
      this.initAlertReaderError();
    }
    if (this.alertReaderDisconnectedError) {
      this.alertReaderDisconnectedError.dismiss();
      this.initAlertReaderDisconnectedError();
    }
    this.isAlertShowing = false;
  }

  onSwipeFound(index) {
    console.log(this.tag, 'Setting as found:', index);
    // this.vizixItemArray[index].found = true;
    this.cdr.detectChanges();
  }

  onSwipeNotFound(index) {
    console.log(this.tag, 'Setting as unfounf:', index);
    // this.vizixItemArray[index].found = false;
    this.cdr.detectChanges();
  }

  // Go back in the navigation flow
  goBack() {
    if (!this.isAlertShowing && !this.isPopPageActive) {
      this.dismissLoading();
      if (this.isGeigerMode) { // If we are showing the geiger, then go back to the list
        this.cancelGeigerMode();
      } else if (this.isFindItemScreenShowing && !this.autoSearchValue && !this.lookupEpcList) { // If we are on the list
        this.cancelInventoryMode();
      } else {
        this.isPopPageActive = true;
        this.popAndSave(!!this.lookupEpcList); // Only if epcList exists, we skip save
      }
    }
    else {
      if (this.popoverDetails) {
        this.popoverDetails.dismiss();
        this.popoverDetails = null;
      }
    }
    this.readerService.dynamicPowerEnable(false);
  }

  /**
   * Pops the view and saves the list for later
   * @param {boolean} skipSave (is optional)
   */
  popAndSave(skipSave?: boolean) {
    if (this.autoSearchValue && this.inventoryShownArray.length > 0 && !skipSave) {
      this.findItemService.saveItems(this.autoSearchValue, this.inventoryShownArray).then(() => {
        this.navCtrl.pop();
      }, () => {
        this.navCtrl.pop(); // If error, pop Page anyway
      });
    } else {
      this.navCtrl.pop();
    }
  }

  clearInput(goBack?: boolean, leaveInputText?: boolean) {
    if (!this.isTriggerPulled && !this.isGeigerMode) {
      this.tagInformationService.reset(this.source);
      if (!leaveInputText) {
        this.searchInputText = '';
      }
      this.totalOnHands = 0;
      this.inventoryShownArray = [];
      this.inventorySearchSet = new Set();
      if (!isUndefined(goBack) && this.isFindItemScreenShowing && !this.autoSearchValue && !this.lookupEpcList) {
        this.isFindItemScreenShowing = false;
        this.isGeigerMode = false;
        this.changeBarcodeMode();
      } else {
        this.goBack();
      }
      this.cdr.detectChanges();
    }
  }

  clearScreen() {
    this.searchInputText = '';
    this.cdr.detectChanges();
  }

  // Shows the zone and dept selection screen
  cancelInventoryMode() {
    console.log(this.tag, 'Cancel Inventory Mode');
    this.clearInput(true);
    this.changeBarcodeMode();
  }

  cancelGeigerMode() {
    console.log(this.tag, 'Cancel Geiger Mode');
    this.clearGeigerMode();
    this.initReaderInventory();
  }

  clearGeigerMode() {
    console.log(this.tag, 'Clearing Geiger Mode');
    this.geigerPercentage = 0;
    this.selectedTag = "";
    this.isGeigerMode = false;
    this.cdr.detectChanges();
  }

  onTouchMove() {
    this.isDragging = true;
  }

  onChangeKeyValue(event)
  {
    let charPressed = event.charAt(event.length - 1);
    if (!charPressed) {
      charPressed = '';
    }
    let regExpression = new RegExp(VALIDATION_INPUT_TAG);
    if (!regExpression.test(<string>charPressed.toUpperCase())) {
      this.searchInputText = event.replace(charPressed, '');
      this.inputTagField.value = this.searchInputText;
    }
    else {
      this.searchInputText = event;
    }
    this.cdr.detectChanges();
  }
}



// WEBPACK FOOTER //
// ./src/pages/find-item/find-item.ts